import { initHdDropdownTracking, setMobileCSSCustomProperties } from '../helpers/util'
import { initGallery } from '../modules/Gallery'
import { requireCountryCode } from '../helpers/util'

let downloadIrReady = false
let downloadIrPromise = null

const deferNonCriticalWork = callback => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout: 1500 })
    return
  }

  window.setTimeout(callback, 1)
}

const loadDownloadInfoRequest = () => {
  if (downloadIrPromise) return downloadIrPromise

  downloadIrPromise = import('../modules/DownloadInfoRequest').then(({ downloadIrSetup }) => {
    downloadIrSetup()
    downloadIrReady = true
  })

  return downloadIrPromise
}

const bootstrapDeferredDownloadInfoRequest = () => {
  document.addEventListener('click', event => {
    if (downloadIrReady) return

    const link = event.target.closest('.js-download-file')
    if (!link) return

    event.preventDefault()
    event.stopImmediatePropagation()

    loadDownloadInfoRequest().then(() => {
      link.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }))
    })
  }, true)
}

document.addEventListener('DOMContentLoaded', () => {
  const referrerField = document.querySelector('.referrer')
  if (referrerField) referrerField.value = document.referrer // Set HTTP referer

  const hasProductAvailabilityToaster = !!document.querySelector('.js-product-availability-toaster')
  const hasQuoteForm = !!document.querySelector('.js-quote-form-container')
  const hasDownloadInfoRequest = !!document.querySelector('.js-download-file-item')

  setMobileCSSCustomProperties()
  initHdDropdownTracking()
  initGallery()

  if (hasProductAvailabilityToaster || hasQuoteForm) {
    deferNonCriticalWork(() => {
      import('../modules/Products').then(({ initProductAvailabilityToaster, initQuoteForm }) => {
        if (hasProductAvailabilityToaster) initProductAvailabilityToaster()
        if (hasQuoteForm) requireCountryCode(initQuoteForm)
      })
    })
  }

  if (hasDownloadInfoRequest) {
    bootstrapDeferredDownloadInfoRequest()
    deferNonCriticalWork(() => {
      loadDownloadInfoRequest()
    })
  }
});
